/**
 * Format a date to "Month Day, Year" format (e.g., "April 6, 2023")
 * @param {Date | string | number} date - The date to format (Date object, ISO string, or timestamp)
 * @returns {string} Formatted date string in "Month Day, Year" format
 */
export const formatDate = (date) => {
  if (!date) return "";

  const dateObj = new Date(date);

  // Check if date is valid
  if (isNaN(dateObj.getTime())) {
    return "";
  }

  const options = { year: "numeric", month: "long", day: "numeric" };
  return dateObj.toLocaleDateString("en-US", options);
};

/**
 * Alternative formatter using Intl API for more control
 * @param {Date | string | number} date - The date to format
 * @returns {string} Formatted date string in "Month Day, Year" format
 */
export const formatDateWithIntl = (date) => {
  if (!date) return "";

  const dateObj = new Date(date);

  if (isNaN(dateObj.getTime())) {
    return "";
  }

  const formatter = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return formatter.format(dateObj);
};
